<template>
    <add-edit-hazard></add-edit-hazard>
</template>

<script>
import AddEditHazard from "@/layouts/components/risk-management/hazards/addedit-hazard.vue";

export default {
 components : {
   AddEditHazard
 },
};
</script>